import { AmeenTheme } from './types';
import { lightSemanticTokens } from '../tokens/semantic';
import { shadows } from '../tokens/base';

export const lightTheme: AmeenTheme = {
  mode: 'light',
  colors: lightSemanticTokens,
  
  spacing: (factor: number) => `${factor * 8}px`,
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  
  typography: {
    fontFamily: 'Noto Kufi Arabic,Alexandria, Segoe UI, Arial, Roboto, Helvetica Neue, sans-serif',
    fontFamilyAr: 'Noto Kufi Arabic, Segoe UI, Arial, sans-serif',
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      '2xl': '24px',
      '3xl': '32px',
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  
  breakpoints: {
    xs: '0px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px',
  },
  
  shadows,
};

